import axios from 'axios';

const moduleAppointments = {
    namespaced: true,
    state: () => ({
        appointments: [],
    }),
    getters: {
        appointments: state => {
            return state.appointments;
        },
    },
    mutations: {
        /**
         * Set the state appointments
         * @param {object} state The state of the Vuex Store
         * @param {object} appointments The new value for appointments
         */
        setAppointments (state, {appointments}) {
            state.appointments = appointments;
        },
    },
    actions: {
        /**
         * Calls the Appointments@update api, and fill the state appointments 
         * @param {object} context Exposes the same set of methods/properties on the store instance
         * @return {Promise<object>}
         */
        fetchAppointments (context) {
            return new Promise((resolve, reject) => {
                context.dispatch('moduleAuth/getValidJWT', null, {root: true}).then((token) => {
                    let url = context.rootState.moduleAuth.heimbasServer + '/api/v1/appointments';
                    let requestData = {
                        headers: {
                            Authorization: token
                        },
                    };
                    //TO DO use the certificate in the axios request
                    // let certificate = context.rootGetters['moduleAuth/jwtCertificate'];
                    axios.get(url, requestData).then((response) => {
                        context.commit('setAppointments', {'appointments': response.data});
                        resolve(response);
                    }).catch((error) => {
                        reject(error);
                    });
                }).catch((error) => {
                    reject(error);
                });
            });
        },

    }
}
export default moduleAppointments;